<template>
  <svg width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0002 10.4997C11.1732 10.4997 10.5002 11.1727 10.5002 11.9997C10.5002 12.8267 11.1732 13.4997 12.0002 13.4997C12.8272 13.4997 13.5002 12.8267 13.5002 11.9997C13.5002 11.1727 12.8272 10.4997 12.0002 10.4997ZM11.9998 15.4996C10.0698 15.4996 8.4998 13.9296 8.4998 11.9996C8.4998 10.0696 10.0698 8.49961 11.9998 8.49961C13.9298 8.49961 15.4998 10.0696 15.4998 11.9996C15.4998 13.9296 13.9298 15.4996 11.9998 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
      
    />
  </svg>
</template>
